import revive_payload_client_YTGlmQWWT5 from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_neSs9z3UJp from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_VeD7Ba96AP from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_VTarsGAzgb from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_PKIXU5KmsI from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import plugin_vue3_xKuw1km5sV from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/.nuxt/components.plugin.mjs";
import prefetch_client_8FoqvPFTot from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import i18n_dOTnCc6TUQ from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import index_DTYw6ioIbr from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/plugins/checkInternetConnection/index.ts";
import index_vhCIiN7XcE from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/plugins/clearCacheBrowser/index.ts";
import index_35lllwRPi9 from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/plugins/redirectToPath/index.ts";
import index_fXuhyXjmgA from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/plugins/polyfill/index.ts";
import index_FDQtqIT8Bx from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/plugins/platform/index.ts";
import index_0ugyfhn90T from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/plugins/webos/index.ts";
import index_S3W5rnM5rL from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/plugins/domains/index.ts";
import index_50DzE9KKAB from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/plugins/appResume/index.ts";
import index_sZtm0ONE0g from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/plugins/firebase/index.ts";
import index_SWVOCfjRDk from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/plugins/analytics/index.ts";
import index_m1ie4Ps7cH from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/plugins/services/index.ts";
import index_Ent9puFLNd from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/plugins/sentry/index.ts";
import index_aUp496vAmf from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/plugins/startup/index.ts";
import index_1R8KPBz7jf from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/plugins/event-bus/index.ts";
import index_5NGiVoVnKZ from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/plugins/spatial-navigator/index.ts";
import index_BHmDTNULLi from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/plugins/runtimeHooks/index.ts";
export default [
  revive_payload_client_YTGlmQWWT5,
  unhead_neSs9z3UJp,
  router_VeD7Ba96AP,
  payload_client_VTarsGAzgb,
  navigation_repaint_client_PKIXU5KmsI,
  plugin_vue3_xKuw1km5sV,
  components_plugin_KR1HBZs4kY,
  prefetch_client_8FoqvPFTot,
  i18n_dOTnCc6TUQ,
  index_DTYw6ioIbr,
  index_vhCIiN7XcE,
  index_35lllwRPi9,
  index_fXuhyXjmgA,
  index_FDQtqIT8Bx,
  index_0ugyfhn90T,
  index_S3W5rnM5rL,
  index_50DzE9KKAB,
  index_sZtm0ONE0g,
  index_SWVOCfjRDk,
  index_m1ie4Ps7cH,
  index_Ent9puFLNd,
  index_aUp496vAmf,
  index_1R8KPBz7jf,
  index_5NGiVoVnKZ,
  index_BHmDTNULLi
]